export const ASSISE_SHOW_RESET = "ASSISE_SHOW_RESET";
export const ASSISE_SHOW_SET_ERROR = "ASSISE_SHOW_SET_ERROR";
export const ASSISE_SHOW_SET_RETRIEVED = "ASSISE_SHOW_SET_RETRIEVED";
export const ASSISE_SHOW_TOGGLE_LOADING = "ASSISE_SHOW_TOGGLE_LOADING";
